export default "__VITE_ASSET__K2jSC_ME__"